import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function PaymentForm({formData, updateFormData}) {

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    // Update the form data in the parent component
    updateFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom style={{color: 'green'}}>
        Payment method
      </Typography>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
        gap: 3,
        width: '100%',
        '& .MuiFormControl-root': { width: '100%' }
      }}>
        <Box>
          <TextField
            required
            id="cardName"
            name="decryptedCardName"
            label="Name on card"
            fullWidth
            autoComplete="cc-name"
            variant="standard"
            onChange={handleInputChange}
            value={formData && formData.decryptedCardName}
          />
        </Box>
        <Box>
          <TextField
            required
            id="cardNumber"
            name="decryptedCardNumber"
            label="Card number"
            fullWidth
            autoComplete="cc-number"
            variant="standard"
            onChange={handleInputChange}
            value={formData && formData.decryptedCardNumber}
          />
        </Box>
        <Box>
          <TextField
            required
            id="expDate"
            name="decryptedExpDate"
            label="Expiry date"
            fullWidth
            autoComplete="cc-exp"
            variant="standard"
            onChange={handleInputChange}
            value={formData && formData.decryptedExpDate}
          />
        </Box>
        <Box>
          <TextField
            required
            id="cvv"
            name="decryptedCVV"
            label="CVV"
            helperText="Last three digits on signature strip"
            fullWidth
            autoComplete="cc-csc"
            variant="standard"
            onChange={handleInputChange}
            value={formData && formData.decryptedCVV}
          />
        </Box>
        {!formData.decryptedCardName === '' && // if no credit card is saved in the database, show 'remember card'
        <Box sx={{ gridColumn: { xs: '1', sm: '1 / -1' } }}>
          <FormControlLabel
            control={<Checkbox color="secondary" name="saveCard" value="yes" />}
            label="Remember credit card details for next time"
          />
        </Box>
        }
      </Box>
    </React.Fragment>
  );
}
